import fetch from 'cross-fetch';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { env } from '../../common/__config__/env';
declare global {
  interface Window {
    __APOLLO_STATE__: any;
    __ENV__: any;
    tinymce: any;
  }
}
const link = createHttpLink({
  uri: env.PM_GRAPH,
  fetch: fetch,
});
const cache = new InMemoryCache();
if (typeof window !== 'undefined') {
  cache.restore(window.__APOLLO_STATE__);
}
export const client = new ApolloClient({
  name: 'privatmegleren_nybygg_client',
  link: link,
  cache: cache,
  ssrForceFetchDelay: 100,
});
